import { Div, Icon, Label, lightTheme, P, X } from '@vgrubs/components';
import { useRef } from 'react';
import styled from 'styled-components';
import { InputArrowIcon } from '../../assets/svg';

const AdminSelectStyled = styled.select<{
  $textCenter?: boolean;
  chevron?: boolean;
  $shadowDesign?: boolean;
  disabled?: boolean;
  $small?: boolean;
  $bold?: boolean;
  $color?: string;
}>`
  position: relative;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.darkGray}80;
  border-radius: 200px;
  font-size: 14px;
  line-height: 18px;
  padding: 0 32px 0 24px;
  display: flex;
  align-items: center;
  height: ${({ theme }) => theme.input.height};
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  color: ${({ theme }) => theme.darkGray};
  background: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  ${({ $small }) =>
    $small &&
    `
    height: 32px;
    font-size: 13px;
    padding: 0 24px 0 14px;
    `}

  ${({ $textCenter }) => $textCenter && `text-align: center;`}

  ${({ $bold }) => $bold && `font-weight: 800;`}

  ${({ $color }) => $color && `color: ${$color};`}

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  /* ${({ chevron }) =>
    chevron &&
    ` */
    /* padding-right: 48px; */
   /* `}; */

  ${({ $shadowDesign, theme }) =>
    $shadowDesign &&
    `
    background: ${theme.white};
    border: 1px solid #e3e3e3;
    box-shadow: ${theme.shadows.shadow1};

  `}

  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1em;
  cursor: pointer;
  :focus {
    outline: none !important;
    border: 1px solid ${({ theme }) => theme.primary};
  }

  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  /* 
  @media (max-width: 800px) {
    height: 40px;
  } */
`;

const IconStyled = styled.div<{
  disabled?: boolean;
  $size?: number;
  $small?: boolean;
}>`
  position: absolute;
  right: ${({ $small }) => ($small ? '12px' : '16px')};
  left: auto;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 1;
  height: ${({ $size }) => $size || 16}px;
  ${({ disabled }) => disabled && `opacity: 0.5;`}
  pointer-events: none;
  touch-action: none;
  /* vertical-align: middle; */
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconStyledClear = styled.div<{ disabled?: boolean }>`
  position: absolute;
  right: 18px;
  left: auto;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 1;
  height: 12px;
  ${({ disabled }) => disabled && `opacity: 0.5;`}
  cursor: pointer;
`;

export const AdminSelect = (
  props: {
    label?: string;
    /** Same contract as AdminInput's: HTML string beside the label. */
    tooltip?: string;
    placeholder?: string;
    options?: JSX.Element;
    $textCenter?: boolean;
    $shadowDesign?: boolean;
    $clearable?: boolean;
    $chevron?: boolean;
    onClear?: () => void;
    $small?: boolean;
    $bold?: boolean;
    $color?: string;
  } & React.SelectHTMLAttributes<HTMLSelectElement>
) => {
  const ref = useRef<HTMLSelectElement>(null);

  const { onClear, tooltip, ...rest } = props;

  return (
    <Div $width={props.$small ? '80px' : '100%'}>
      {/* Only a tooltip switches to the shared Label - the plain case keeps
          its own markup so every existing select renders unchanged. */}
      {props.label &&
        (tooltip ? (
          <Label
            label={props.label}
            tooltip={tooltip}
            $textCenter={props.$textCenter}
          />
        ) : (
          <P $mb="8" $ml="24" $mr="24" $center={props.$textCenter}>
            <b>{props.label}</b>
          </P>
        ))}
      <Div $relative>
        <AdminSelectStyled
          ref={ref}
          placeholder={props.placeholder}
          $shadowDesign={props.$shadowDesign}
          $chevron={props.$chevron}
          $small={props.$small}
          $bold={props.$bold}
          $color={props.$color}
          {...rest}
        >
          {props.options}
        </AdminSelectStyled>
        {props.$clearable && (
          <IconStyledClear
            size="12"
            {...(rest as any)}
            onClick={(e) => {
              e.stopPropagation();
              props.onClear?.();
            }}
          >
            <Icon $pointer $size="12">
              <X fill={lightTheme.darkGray} />
            </Icon>
          </IconStyledClear>
        )}
        {!props.$clearable && (
          <IconStyled
            {...(rest as any)}
            onClick={(e) => {
              e.stopPropagation();
            }}
            $small={props.$small}
          >
            <Icon $size={props.$small && 10}>
              <InputArrowIcon />
            </Icon>
          </IconStyled>
        )}
      </Div>
    </Div>
  );
};
